import axios from "axios";
import { swalAlertDanger, swalAlertTimer } from "../components/common/Alerts";

const instanceAPI = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor para respuestas
instanceAPI.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        await swalAlertTimer("SESION EXPIRADA", 3000);
        window.location.href = "/";
      } else {
        swalAlertDanger(
          "ERROR EN LA OBTENCION DE DATOS",
          error.message,
          () => {}
        );
      }
    }
    return Promise.reject(error);
  }
);

export default instanceAPI;
